import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default class PageAbout {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }

  async init() {
    this.handleSections()
  }

  handleSections() {
    const sections = this.dom.querySelectorAll('.about-section')

    sections.forEach((section, i) => {
        switch (i) {
            case 0:
                gsap.to(section, {
                    opacity: 1,
                    scrollTrigger: {
                      trigger: section.querySelector('.section-main'),
                      start: "top bottom",
                      end: "+=100%",
                      scrub: true,
                    //   markers: true,
                    }
                })

                gsap.fromTo(section.querySelector('.bg img'), {
                  scale: 1.2,
                },{
                  scale: 1,
                  scrollTrigger: {
                    trigger: section.querySelector('.section-main'),
                    start: "top bottom",
                    end: () => {
                      return `+=150%`
                    },
                    scrub: true,
                  }
                })
                
                gsap.to(section.querySelector('.main-content'), {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                      trigger: section.querySelector('.main .breakout'),
                      start: "top bottom",
                      end: () => {
                        // return `+=${section.querySelector('.main-content').offsetHeight}`
                        return `+=50%`
                      },
                      scrub: true,
                    //   markers: true,
                    }
                })

                gsap.to(section.querySelector('.bg img'), {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: section,
                        // trigger: section.querySelector('.section-main'),
                        start: "200% bottom",
                        end: () => {
                            // return `+=${section.querySelector('.main-content').offsetHeight}`
                            return `+=100%`
                        },
                        //   pin: true,
                        scrub: true,
                        // markers: true,
                    }
                })

                gsap.to(section.querySelector('.main'), {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: section,
                        start: "200% bottom",
                        end: () => {
                            return `+=50%`
                        },
                        //   pin: true,
                        scrub: true,
                        // markers: true,
                    }
                })
                break;

            case sections.length - 1:
                gsap.to(section.querySelector('.bg'), {
                    scale: 1,
                    scrollTrigger: {
                      trigger: section.querySelector('.section-main'),
                      start: "top top",
                      end: "+=100%",
                      scrub: true,
                    //   markers: true,
                    }
                })
                gsap.to(section, {
                    opacity: 1,
                    scrollTrigger: {
                      trigger: section.querySelector('.section-main'),
                      start: "top top",
                      end: "+=100%",
                      scrub: true,
                      pin: true,
                    //   markers: true,
                    }
                })

                gsap.to(section.querySelector('.main-content'), {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                      trigger: section.querySelector('.main .breakout'),
                      start: "top bottom",
                      end: () => {
                        // return `+=${section.querySelector('.main-content').offsetHeight}`
                        return `+=50%`
                      },
                      scrub: true,
                    //   markers: true,
                    }
                })
                break;

            default:
                gsap.to(section.querySelector('.bg'), {
                    scale: 1,
                    scrollTrigger: {
                      trigger: section.querySelector('.section-main'),
                      start: "top top",
                      end: "+=100%",
                      scrub: true,
                    //   markers: true,
                    }
                })
                gsap.to(section, {
                    opacity: 1,
                    scrollTrigger: {
                      trigger: section.querySelector('.section-main'),
                      start: "top top",
                      end: "+=100%",
                      scrub: true,
                    //   pin: true,
                    //   markers: true,
                    }
                })

                gsap.to(section.querySelector('.main-content'), {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                      trigger: section.querySelector('.main .breakout'),
                      start: "top bottom",
                      end: () => {
                        // return `+=${section.querySelector('.main-content').offsetHeight}`
                        return `+=50%`
                      },
                      scrub: true,
                    //   markers: true,
                    }
                })

                gsap.to(section.querySelector('.bg img'), {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: section,
                        // trigger: section.querySelector('.section-main'),
                        start: "150% top",
                        end: () => {
                            // return `+=${section.querySelector('.main-content').offsetHeight}`
                            return `+=100%`
                        },
                        //   pin: true,
                        scrub: true,
                        // markers: true,
                    }
                })

                gsap.to(section.querySelector('.main'), {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: section,
                        start: "150% top",
                        end: () => {
                            return `+=50%`
                        },
                        //   pin: true,
                        scrub: true,
                        // markers: true,
                    }
                })
                break;
        }
    });
  }

  resize() {
  }

  destory() {

  }
}
